import { render, staticRenderFns } from "./CookieComponent.vue?vue&type=template&id=de61d456&scoped=true"
import script from "./CookieComponent.vue?vue&type=script&lang=js"
export * from "./CookieComponent.vue?vue&type=script&lang=js"
import style0 from "./CookieComponent.vue?vue&type=style&index=0&id=de61d456&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de61d456",
  null
  
)

export default component.exports